import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

type Language = 'ru' | 'uz';

interface Translations {
  [key: string]: {
    ru: string;
    uz: string;
  };
}

const translations: Translations = {
  // Navigation
  home: { ru: 'Главная', uz: 'Bosh sahifa' },
  search: { ru: 'Поиск', uz: 'Qidirish' },
  myListings: { ru: 'Мои объявления', uz: "Mening e'lonlarim" },
  admin: { ru: 'Админ', uz: 'Admin' },
  login: { ru: 'Войти', uz: 'Kirish' },
  logout: { ru: 'Выход', uz: 'Chiqish' },

  // Property types
  apartment: { ru: 'Квартира', uz: 'Kvartira' },
  house: { ru: 'Дом', uz: 'Uy' },
  allTypes: { ru: 'Все', uz: 'Hammasi' },

  // Filters
  filters: { ru: 'Фильтры', uz: 'Filtrlar' },
  propertyType: { ru: 'Тип недвижимости', uz: 'Mulk turi' },
  city: { ru: 'Город', uz: 'Shahar' },
  enterCity: { ru: 'Введите город', uz: 'Shaharni kiriting' },
  price: { ru: 'Цена', uz: 'Narx' },
  from: { ru: 'От', uz: 'Dan' },
  to: { ru: 'До', uz: 'Gacha' },
  area: { ru: 'Площадь', uz: 'Maydon' },
  rooms: { ru: 'Количество комнат', uz: 'Xonalar soni' },
  apply: { ru: 'Применить', uz: "Qo'llash" },
  reset: { ru: 'Сброс', uz: 'Tozalash' },

  // Property details
  sqm: { ru: 'м²', uz: 'm²' },
  roomsShort: { ru: 'комн.', uz: 'xona' },
  floor: { ru: 'Этаж', uz: 'Qavat' },
  totalFloors: { ru: 'Всего этажей', uz: 'Jami qavatlar' },
  bathrooms: { ru: 'Санузлы', uz: 'Hojatxonalar' },
  description: { ru: 'Описание', uz: 'Tavsif' },
  contactSeller: { ru: 'Связаться с продавцом', uz: "Sotuvchi bilan bog'lanish" },
  sellerInfo: { ru: 'Контакты продавца', uz: "Sotuvchi ma'lumotlari" },
  sellerName: { ru: 'Имя продавца', uz: 'Sotuvchi ismi' },
  sellerPhone: { ru: 'Номер телефона', uz: 'Telefon raqami' },
  callPhone: { ru: 'Позвонить', uz: "Qo'ng'iroq qilish" },
  openTelegram: { ru: 'Написать в Telegram', uz: 'Telegramda yozish' },
  close: { ru: 'Закрыть', uz: 'Yopish' },
  back: { ru: 'Назад', uz: 'Orqaga' },
  sold: { ru: 'ПРОДАНО', uz: 'SOTILDI' },
  address: { ru: 'Адрес', uz: 'Manzil' },

  // Dashboard
  dashboard: { ru: 'Мои объявления', uz: "Mening e'lonlarim" },
  welcome: { ru: 'Добро пожаловать', uz: 'Xush kelibsiz' },
  createListing: { ru: 'Создать объявление', uz: "E'lon yaratish" },
  noListings: { ru: 'У вас пока нет объявлений', uz: "Sizda hali e'lonlar yo'q" },
  createFirstListing: { ru: 'Создайте первое объявление о продаже недвижимости', uz: "Ko'chmas mulk sotish bo'yicha birinchi e'loningizni yarating" },
  edit: { ru: 'Редактировать', uz: 'Tahrirlash' },
  delete: { ru: 'Удалить', uz: "O'chirish" },
  confirmDelete: { ru: 'Вы уверены, что хотите удалить это объявление?', uz: "Haqiqatan ham bu e'lonni o'chirib tashlamoqchimisiz?" },
  created: { ru: 'Создано', uz: 'Yaratildi' },
  photosLabel: { ru: 'Фотографии', uz: 'Rasmlar' },
  photosHint: { ru: '(минимум 2, максимум 7 фото)', uz: '(kamida 2 ta, ko\'pi bilan 7 ta rasm)' },
  uploadPhotosMinError: { ru: 'Пожалуйста, загрузите минимум 2 фотографии!', uz: 'Iltimos, kamida 2 ta rasm yuklang!' },
  uploadPhotosMaxError: { ru: 'Максимально 7 фотографий!', uz: 'Maksimal 7 ta rasm yuklash mumkin!' },
  yourBalance: { ru: 'Ваш баланс', uz: 'Balansingiz' },
  topup: { ru: 'Пополнить', uz: "To'ldirish" },
  costPerListing: { ru: 'Стоимость одного объявления', uz: "Bitta e'lon narxi" },
  freePosting: { ru: 'Бесплатно', uz: 'Bepul' },

  // Property status
  pending: { ru: 'На модерации', uz: 'Tekshirilmoqda' },
  active: { ru: 'Активно', uz: 'Faol' },
  rejected: { ru: 'Отклонено', uz: 'Rad etildi' },

  // Create listing form
  title: { ru: 'Название', uz: 'Sarlavha' },
  titlePlaceholder: { ru: 'Например: 2-комнатная квартира в Самарканде', uz: 'Masalan: 2 xonali kvartira Samarqandda' },
  descPlaceholder: { ru: 'Подробное описание недвижимости...', uz: "Mulk haqida batafsil ma'lumot..." },
  cityPlaceholder: { ru: 'Самарканд, Ташкент...', uz: 'Samarqand, Toshkent...' },
  addressPlaceholder: { ru: 'Улица, номер дома...', uz: "Ko'cha, uy raqami..." },
  create: { ru: 'Создать', uz: 'Yaratish' },
  cancel: { ru: 'Отмена', uz: 'Bekor qilish' },
  save: { ru: 'Сохранить', uz: 'Saqlash' },
  update: { ru: 'Обновить', uz: 'Yangilash' },

  // Admin
  adminPanel: { ru: 'Панель администратора', uz: 'Administrator paneli' },
  pricingPlans: { ru: 'Тарифные планы', uz: 'Tarif rejalar' },
  users: { ru: 'Пользователи', uz: 'Foydalanuvchilar' },
  categories: { ru: 'Категории', uz: 'Kategoriyalar' },
  statistics: { ru: 'Статистика', uz: 'Statistika' },
  moderation: { ru: 'Модерация', uz: 'Moderatsiya' },
  settingsTab: { ru: 'Настройки', uz: 'Sozlamalar' },
  listingPriceSettingTitle: { ru: 'Стоимость размещения объявлений', uz: "E'lon joylashtirish narxi" },
  setPrice: { ru: 'Установить цену', uz: "Narxni o'rnatish" },
  priceSetSuccess: { ru: 'Стоимость успешно сохранена!', uz: 'Narx muvaffaqiyatli saqlandi!' },
  addPlan: { ru: 'Добавить план', uz: "Reja qo'shish" },
  addCategory: { ru: 'Добавить категорию', uz: "Kategoriya qo'shish" },
  totalUsers: { ru: 'Всего пользователей', uz: 'Jami foydalanuvchilar' },
  totalProperties: { ru: 'Всего объявлений', uz: "Jami e'lonlar" },
  activeProperties: { ru: 'Активные объявления', uz: "Faol e'lonlar" },
  pendingProperties: { ru: 'На модерации', uz: 'Tekshirilmoqda' },
  newUsersToday: { ru: 'Новых пользователей сегодня', uz: 'Bugun yangi foydalanuvchilar' },
  newPropertiesToday: { ru: 'Новых объявлений сегодня', uz: "Bugun yangi e'lonlar" },
  approve: { ru: 'Одобрить', uz: 'Tasdiqlash' },
  reject: { ru: 'Отклонить', uz: 'Rad etish' },
  name: { ru: 'Название', uz: 'Nomi' },
  actions: { ru: 'Действия', uz: 'Amallar' },
  status: { ru: 'Статус', uz: 'Holat' },
  owner: { ru: 'Владелец', uz: 'Egasi' },

  // Login
  loginTitle: { ru: 'Вход в систему', uz: 'Tizimga kirish' },
  loginDescription: { ru: 'Введите свои учетные данные для входа', uz: "Kirish uchun ma'lumotlaringizni kiriting" },
  telegramId: { ru: 'Telegram ID', uz: 'Telegram ID' },
  password: { ru: 'Пароль', uz: 'Parol' },
  username: { ru: 'Логин', uz: 'Login' },
  enterTelegramId: { ru: 'Введите ваш Telegram ID', uz: 'Telegram ID-ingizni kiriting' },
  enterPassword: { ru: 'Введите пароль', uz: 'Parolni kiriting' },
  enterUsername: { ru: 'Введите логин', uz: 'Loginni kiriting' },
  newUser: { ru: 'Новый пользователь?', uz: 'Yangi foydalanuvchi?' },
  registerViaTelegram: { ru: 'Зарегистрируйтесь через Telegram бот', uz: 'Telegram bot orqali ro\'yxatdan o\'ting' },
  loginError: { ru: 'Неверные учетные данные', uz: "Noto'g'ri ma'lumotlar" },
  loggingIn: { ru: 'Вход...', uz: 'Kirish...' },
  telegramWebAppHint: { ru: 'Используйте Telegram WebApp для быстрого входа без пароля', uz: 'Parolsiz tez kirish uchun Telegram WebApp dan foydalaning' },
  adminLoginTitle: { ru: 'Вход для администраторов', uz: 'Administratorlar uchun kirish' },
  enterAdminPanel: { ru: 'Войти в панель', uz: 'Panelga kirish' },
  duration: { ru: 'Срок', uz: 'Muddat' },
  days: { ru: 'дней', uz: 'kun' },

  // Home page
  heroTitle: { ru: 'Найдите дом своей мечты', uz: 'Orzuingizdagi uyni toping' },
  heroDescription: { ru: 'Тысячи объявлений о продаже квартир и домов. Быстрый поиск, удобные фильтры, проверенные продавцы.', uz: "Minglab kvartira va uy sotish e'lonlari. Tez qidiruv, qulay filtrlar, tekshirilgan sotuvchilar." },
  searchPlaceholder: { ru: 'Поиск по гороdu, адресу или названию...', uz: "Shahar, manzil yoki sarlavha bo'yicha qidiruv..." },
  findBtn: { ru: 'Найти', uz: 'Qidirish' },
  listingsCount: { ru: 'Объявлений', uz: "E'lonlar" },
  citiesCount: { ru: 'Городов', uz: 'Shaharlar' },
  verifiedCount: { ru: 'Проверенных', uz: 'Tekshirilgan' },
  freshListings: { ru: 'Свежие объявления', uz: "Yangi e'lonlar" },
  foundCount: { ru: 'Найдено объявлений', uz: "ta e'lon topildi" },
  viewAllListings: { ru: 'Смотреть все объявления', uz: "Barcha e'lonlarni ko'rish" },
  noPropertiesFound: { ru: 'Объявления не найдены', uz: "E'lonlar topilmadi" },
  noPropertiesYet: { ru: 'Пока нет активных объявлений. Будьте первым!', uz: "Hozircha faol e'lonlar yo'q. Birinchi bo'ling!" },
  loginAndPost: { ru: 'Войти и разместить', uz: "Kirish va e'lon berish" },
  startSearch: { ru: 'Начать поиск', uz: 'Qidiruvni boshlash' },
  howItWorks: { ru: 'Как это работает', uz: 'Bu qanday ishlaydi' },
  step1Title: { ru: '1. Поиск', uz: '1. Qidiruv' },
  step1Description: { ru: 'Используйте фильтры для быстрого поиска подходящей недвижимости', uz: "Mos ko'chmas mulkni tez topish uchun filtrlardan foydalaning" },
  step2Title: { ru: '2. Просмотр', uz: '2. Ko\'rib chiqish' },
  step2Description: { ru: 'Изучайте детальную информацию, фотографии и характеристики', uz: "Batafsil ma'lumot, rasmlar va xususiyatlarni o'rganing" },
  step3Title: { ru: '3. Связь', uz: '3. Bog\'lanish' },
  step3Description: { ru: 'Свяжитесь с продавцом и договоритесь о просмотре', uz: "Sotuvchi bilan bog'laning va ko'rib chiqish haqida kelishing" },
  wantToSell: { ru: 'Хотите продать недвижимость?', uz: "Ko'chmas mulk sotmoqchimisiz?" },
  wantToSellDescription: { ru: 'Зарегистрируйтесь и размещайте объявления о продаже вашей недвижимости. Миллионы покупателей увидят ваше объявление.', uz: "Ro'yxatdan o'ting va ko'chmas mulkingizni sotish bo'yicha e'lon joylashtiring. Millionlab xaridorlar sizning e'loningizni ko'rishadi." },
  easyListing: { ru: 'Простое размещение объявлений', uz: "Oddiy e'lon joylashtirish" },
  flexiblePlans: { ru: 'Гибкие тарифные планы', uz: 'Moslashuvchan tarif rejalar' },
  millionsBuyers: { ru: 'Доступ к миллионам покупателей', uz: 'Millionlab xaridorlarga kirish' },
  postListing: { ru: 'Разместить объявление', uz: "E'lon joylashtirish" },
  tgBotHint: { ru: '🤖 Откройте Telegram бот — поделитесь номером и сразу переходите в кабинет', uz: '🤖 Telegram botni oching — raqamingizni yuboring va darhol kabinetga kiring' },
  latestListings: { ru: 'Последние объявления', uz: "So'nggi e'lonlar" },
  noListingsYet: { ru: 'Объявлений пока нет', uz: "Hali e'lonlar yo'q" },
  beFirstToPost: { ru: 'Будьте первым!', uz: 'Birinchi bo\'ling!' },

  // Search page
  searchTitle: { ru: 'Поиск недвижимости', uz: "Ko'chmas mulk qidirish" },
  noResults: { ru: 'Ничего не найдено', uz: 'Hech narsa topilmadi' },
  noResultsDescription: { ru: 'Попробуйте изменить фильтры поиска', uz: 'Qidiruv filtrlarini o\'zgartirib ko\'ring' },
  page: { ru: 'Страница', uz: 'Sahifa' },
  next: { ru: 'Вперед', uz: 'Keyingi' },
  previous: { ru: 'Назад', uz: 'Oldingi' },

  // Footer
  footerDescription: { ru: 'Платформа для поиска и продажи недвижимости', uz: "Ko'chmas mulk qidirish va sotish platformasi" },
  navigation: { ru: 'Навигация', uz: 'Navigatsiya' },
  contacts: { ru: 'Контакты', uz: 'Aloqa' },
  allRightsReserved: { ru: 'Все права защищены', uz: 'Barcha huquqlar himoyalangan' },

  // Common
  loading: { ru: 'Загрузка...', uz: 'Yuklanmoqda...' },
  error: { ru: 'Ошибка', uz: 'Xato' },
  success: { ru: 'Успешно', uz: 'Muvaffaqiyatli' },
  notFound: { ru: 'Не найдено', uz: 'Topilmadi' },
  sum: { ru: 'сум', uz: "so'm" },
};

interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string) => string;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

export const LanguageProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [language, setLanguage] = useState<Language>(() => {
    const saved = localStorage.getItem('language');
    return (saved as Language) || 'uz'; // По умолчанию узбекский для целевой аудитории
  });

  useEffect(() => {
    localStorage.setItem('language', language);
    document.documentElement.lang = language;
  }, [language]);

  const t = (key: string): string => {
    return translations[key]?.[language] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};
